import moment from 'moment';
import Vue from 'vue'

class Util {
    static initialStrFromDay(day){
        var str = "";
        switch(day){
            case 0:
                str = "일";
                break;
            case 1:
                str = "월";
                break;
            case 2:
                str = "화";
                break;
            case 3:
                str = "수";
                break;
            case 4:
                str = "목";
                break;
            case 5:
                str = "금";
                break;
            case 6:
                str = "토";
                break;
        }
        return str
    }

    static setPhoneFormatter(el){
        var patternStr = "-";
        var patternLocationArr = [4, 9];//몇번째 칸인지 나타냄
        var keyDownLength = 0;
        //var el = document.getElementById(id);
        el.addEventListener("keydown", function(e){
            keyDownLength = e.currentTarget.value.length ;
        });

        function checkAddedAndNotMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] && !isNaN(text[patternLocationArr[i] - 1])){
                    return true;
                }
            }
            return false;
        }

        function checkAddedAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] - 1){
                    return true;
                }
            }
            return false;
        }

        function checkBackSpaceAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i]){
                    return true;
                }
            }
            return false;
        }

        el.addEventListener("keyup", function(e){

            var target = e.currentTarget;
            var text = target.value;
            var pattern = /^(\d{1,3}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)$/g;
            var textMaxIndex = text.length - 1
            var isBackspace = false;
            if(target.selectionStart != text.length) return true;

            if(text.length == keyDownLength - 1) isBackspace = true;

            if(!pattern.test(text)){
                if(checkAddedAndNotMatched(text)){
                    target.value = text.substr(0, textMaxIndex) + patternStr + text[textMaxIndex];
                }else {
                    target.value = text.substr(0, textMaxIndex);
                }
            }else{
                if(checkAddedAndMatched(text) && !isBackspace){
                    target.value = text + patternStr;
                }else if(isBackspace && checkBackSpaceAndMatched(target.value)){
                    target.value = target.value.substr(0, textMaxIndex);
                }
            }
        })
    }


    static setCardNumberFormmater(el){
        this.setFormmatter(el, '-', [5, 10, 15], () => {return /^(\d{1,4}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)$/g;});
    }

    static setCardMMYYFormmater(el){
        this.setFormmatter(el, '/', [3], () => {return /^(\d{1,2}|$)(\/|$)(\d{1,2}|$)$/g;});
    }

    static setYYYYMMDDFormmater(el){
        this.setFormmatter(el, '/', [5, 8], () => {return /^(\d{1,4}|$)(\/|$)(\d{1,2}|$)(\/|$)(\d{1,2}|$)$/g;});
    }

    static setBirthdayFormmater(el){
        this.setFormmatter(el, '-', [5, 8], () => {return /^(\d{1,4}|$)(-|$)(\d{1,2}|$)(-|$)(\d{1,2}|$)$/g;});
    }

    static setJuminFormmater(el){
        this.setFormmatter(el, '-', [7], () => {return /^(\d{1,6}|$)(-|$)(\d{1,7}|$)$/g;});
    }

    static setFormmatter(el, patternStr, patternLocationArr, pPattern){
        var keyDownLength = 0;
        //var el = document.getElementById(id);
        el.addEventListener("keydown", function(e){
            keyDownLength = e.currentTarget.value.length ;
        });

        function checkAddedAndNotMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] && !isNaN(text[patternLocationArr[i] - 1])){
                    return true;
                }
            }
            return false;
        }

        function checkAddedAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] - 1){
                    return true;
                }
            }
            return false;
        }

        function checkBackSpaceAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i]){
                    return true;
                }
            }
            return false;
        }

        el.addEventListener("keyup", function(e){
            var target = e.currentTarget;
            var text = target.value;
            var pattern = pPattern();
            var textMaxIndex = text.length - 1
            var isBackspace = false;
            if(target.selectionStart != text.length) return true;

            if(text.length == keyDownLength - 1) isBackspace = true;

            if(!pattern.test(text)){
                if(checkAddedAndNotMatched(text)){
                    target.value = text.substr(0, textMaxIndex) + patternStr + text[textMaxIndex];
                }else {
                    target.value = text.substr(0, textMaxIndex);
                }
            }else{
                if(checkAddedAndMatched(text) && !isBackspace){
                    target.value = text + patternStr;
                }else if(isBackspace && checkBackSpaceAndMatched(target.value)){
                    target.value = target.value.substr(0, textMaxIndex);
                }
            }
        })
    }

    static setDateToMD(dateStr){
        if(!dateStr) return '';
        const month = parseInt(dateStr.substr(5, 2));
        const date = parseInt(dateStr.substr(8, 2));

        return month + '/' + date;
    }

    static copyToClipboard(copyStr){
        window.copyToClipboard(copyStr);
    }

    static getYYYYDotMMDotDDDayStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY.MM.DD');
        showDateStr += "(" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    static getMMSlashDDDayStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('MM/DD');
        showDateStr += " (" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    static getMMDDDayHangulStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY년 MM월 DD일');
        showDateStr += ' ' + this.initialStrFromDay(momentInstance.day()) + "요일";
        return showDateStr
    }

    //9월 16일
    static getMDDHangulStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
        var showDateStr = momentInstance.format('M월 DD일');
        return showDateStr
    }

    static getMMHangulStr(dateStr){
        return moment(dateStr, "YYYY-MM").format('YYYY년 MM월');
    }

    static getYYYMMDDHangulStr(dateStr){
        return moment(dateStr, "YYYY-MM-DD").format('YYYY년 MM월 DD일');
    }

    static getMMDDDayBracketStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY년 MM월 DD일');
        showDateStr += ' (' + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    static getTimeGapStr(begin_date_time, end_date_time){
        const startMoment = moment(begin_date_time, "YYYY-MM-DD HH:mm:ss");
        const endMoment = moment(end_date_time, "YYYY-MM-DD HH:mm:ss");
        const diff_minutes = endMoment.diff(startMoment,'minutes');
        const minutes = diff_minutes % 60;
        const hour = parseInt(diff_minutes / 60);
        const str = (hour > 0 ? hour + '시간 ' : '') + (minutes > 0 ? minutes + '분' : '');
        return str;
    }

    static showBrowser(url){
        url = url.replace('/?', '?');
        const device = Vue.$cookies.get('device');
        if(device === 'android'){
            window.Android.showBrowser(url);
        }else if(device === 'ios'){
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'showBrowser', url : url});
        }
    }

    static getMMDDDayStr(dateStr){
        if(!dateStr) return '';
        if(dateStr.substr(8, 2) == '00'){
            return '';
        }
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('MM월 DD일');
        showDateStr += "(" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    static async checkAfterLogin(){

    }

}

export default Util
